import { render } from "./NervTicker.vue?vue&type=template&id=d950eba4&scoped=true&ts=true"
import script from "./NervTicker.vue?vue&type=script&lang=ts"
export * from "./NervTicker.vue?vue&type=script&lang=ts"

import "./NervTicker.vue?vue&type=style&index=0&id=d950eba4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d950eba4"]])

export default __exports__